

























































































































import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Key, KeyType } from "bancojs";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";

@Component({
  components: {
    AgDataTable,
  },
})
export default class AdminKeysIndex extends Vue {
  async created() {
    this.loadData();
  }

  async loadData() {
    try {
      this.table.loading = true;
      const res = await $api.client.admin.keys.find({}).toPromise();
      this.table.data = res.content;
    } catch (err) {
      console.log(err);
    } finally {
      this.table.loading = false;
    }
  }

  getTypeString(val: KeyType) {
    switch (val) {
      case "PERSISTENT":
        return "PERSISTENTE";
      case "WRAPPED":
        return "ENCAPSULADA";
      case "WRAPPING":
        return "ENCAPSULAMIENTO";
    }
  }

  openRemove(item: Key) {
    this.table.selected = item;
  }

  closeRemove() {
    this.table.selected = null;
    this.dialog.valid = false;
    this.dialog.confirm = null;
  }

  get removeDialog() {
    return !!this.table.selected;
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    matches: (val: string) =>
      (this.table.selected && this.table.selected.alias == val) ||
      "El alias de la llave no es correcto.",
  };

  async removeUser(id: number) {
    try {
      this.dialog.loading = true;
      await $api.client.admin.keys.destroy(id).toPromise();
      this.dialog.loading = false;
      this.closeRemove();
      await this.loadData();
    } catch (err) {
      console.log(err);
      this.dialog.loading = false;
      this.closeRemove();
    }
  }

  dialog: {
    loading: boolean;
    valid: boolean;
    confirm: string | null;
  } = {
    loading: false,
    valid: false,
    confirm: null,
  };

  table: {
    loading: boolean;
    selected: Key | null;
    data?: Key[];
    options: AgDataTableOptions[];
  } = {
    loading: true,
    selected: null,
    data: undefined,
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "ID",
          value: "id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "{id}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Alias",
          value: "alias",
          class: "text-no-wrap",
        },
        row: {
          type: "TEXT",
        },
      },
      {
        header: {
          text: "Tipo",
          value: "type",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {},
          transform: (val: KeyType) => {
            return this.getTypeString(val);
          },
        },
      },
      {
        header: {
          text: "Dueño",
          value: "user_id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "/admin/users/{user_id}/edit",
        },
      },
      {
        header: {
          text: "CSR",
          value: "id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "/admin/keys/{id}/csr",
          transform: (val: string) => {
            return "Ir a CSR";
          },
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Editar",
              icon: "mdi-pencil",
              link: "{id}/edit",
              append: true,
            },
            {
              label: "Eliminar",
              icon: "mdi-delete",
              action: (item: Key) => {
                this.openRemove(item);
              },
            },
          ],
        },
      },
    ],
  };
}
